import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const content: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  p: (p) => p.spacing(1, 2, 1.5, 2),
};

export const borderedBox: SxStyle = {
  borderRadius: (p) => p.spacing(0.5),
  border: (p) => `1px solid ${p.palette.primary[100]}`,
  background:
    'linear-gradient(150deg, #e5eaff -0.45%, #fff 10.59%, #fff 99.77%)',
};

export const header: SxStyle = {
  background: (p) => p.palette.primary[50],
};

export const box: SxStyle = {
  display: 'flex',
  flex: 1,
};
